import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Australia from "../../pages/2024/australia";
import Japan2024 from "../../pages/2024/japan";
import Footer from "./footer";
import "./layout.css";
import Navigator from "./navigator";
import Homepage from "../../pages/homepage";
import Resume from "../../pages/resume";
import Blogs from "../../pages/blogs";
import Japan from "../../pages/2023/japan";
import Yantai from "../../pages/2023/yantai";
import Vietnam from "../../pages/2024/vietnam";
import Malaysia from "../../pages/2024/malaysia";
import Graduate from "../../pages/2024/graduate";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { MyThemeProvider } from "../../contexts/themecontext";

function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${pathname === "/" ? "Home" : pathname === "/resume" ? "Resume" : pathname === "/blogs" ? "Journal" : "Travel journal"} — Zijie Lin / Enqurance`;
  }, [pathname]);
  return null;
}
const Layout = () => (
  <MyThemeProvider>
    <CssBaseline />
    <Router>
      <RouteEffects />
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <div className="site-shell">
        <Navigator />
        <main id="main-content">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/posts/2023/japan" element={<Japan />} />
            <Route path="/posts/2023/yantai" element={<Yantai />} />
            <Route path="/posts/2024/vietnam" element={<Vietnam />} />
            <Route path="/posts/2024/malaysia" element={<Malaysia />} />
            <Route path="/posts/2024/graduate" element={<Graduate />} />
            <Route path="/posts/2024/australia" element={<Australia />} />
            <Route path="/posts/2024/japan" element={<Japan2024 />} />
            <Route
              path="*"
              element={
                <div className="not-found">
                  <h1>A trail yet to be written.</h1>
                  <p>This journal entry is not available yet.</p>
                  <a href="/blogs">Back to the journal ↗</a>
                </div>
              }
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  </MyThemeProvider>
);
export default Layout;
